import React from 'react';
import { HDate } from '@hebcal/core';
import { computeSeasonalPrayers } from '../../../../engine/halacha/seasonalPrayers';
import '../../WeatherWidget.css';

const Compact = ({ weather, loading, error, getWeatherIcon, title = 'מזג אוויר', showTitle = false }) => {
  if (loading) {
    return (
      <div style={{
        padding: '15px',
        textAlign: 'center',
        color: '#8D6E63'
      }}>
        טוען נתונים...
      </div>
    );
  }

  const now = new Date();
  const hdate = new HDate(now);
  const { mashivHaruach } = computeSeasonalPrayers(hdate, true, 'sephardic', now);
  const halachicStatus = mashivHaruach ? '"משיב הרוח ומוריד הגשם"' : '"מוריד הטל"';

  return (
    <div
      style={{
        padding: '15px',
        direction: 'rtl',
        position: 'relative',
        minWidth: '220px'
      }}
    >
      {/* Title */}
      {showTitle && (
        <div style={{
          fontSize: '18px',
          fontWeight: 'bold',
          color: '#3E2723',
          marginBottom: '12px',
          textAlign: 'center'
        }}>
          {title}
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <div>
          <div style={{
            fontSize: '32px',
            fontWeight: 'bold',
            color: '#3E2723',
            lineHeight: '1',
          }}>
            {Math.round(weather?.main?.temp || 24)}°
          </div>
          <p style={{ margin: 0, color: '#795548', fontSize: '14px', fontWeight: 'bold' }}>
            {weather?.name || 'ירושלים'}
          </p>
        </div>

        {/* אייקון מזג אוויר גדול */}
        <div style={{ fontSize: '40px' }}>
          {getWeatherIcon(weather?.weather?.[0]?.icon)}
        </div>
      </div>

      {/* פרטי לחות ורוח בעיצוב תורני */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '11px',
        color: '#8D6E63',
        borderTop: '1px solid #D7CCC8',
        paddingTop: '8px',
        fontWeight: 'bold'
      }}>
        <span>לחות: {weather?.main?.humidity || 45}%</span>
        <span>רוח: {Math.round((weather?.wind?.speed || 4.2) * 3.6)} קמ"ש</span>
      </div>

      {/* תווית הלכתית - הסגנון החום */}
      <div style={{
        marginTop: '10px',
        fontSize: '12px',
        color: '#3E2723',
        fontWeight: '900',
        textAlign: 'center',
        backgroundColor: '#FFF8E1',
        padding: '4px',
        borderRadius: '4px',
        border: '1px solid #D7CCC8',
      }}>
        {halachicStatus}
      </div>

      {error && weather && (
        <div style={{
          color: '#FFA726',
          fontSize: '10px',
          marginTop: '5px',
          textAlign: 'center',
          fontStyle: 'italic'
        }}>
          ⚠️ מוצג מידע אחרון שנשמר
        </div>
      )}
      {error && !weather && (
        <div style={{ color: 'red', fontSize: '10px', marginTop: '5px', textAlign: 'center' }}>
          שגיאה בטעינת נתונים
        </div>
      )}
    </div>
  );
};

export default Compact;